export default __webpack_public_path__ + "static/championsLeagueFlag-1f947ef54ffff69bd974874d5edb947d.svg";